import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import { Inbox } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    minHeight: 300,
    textAlign: 'center',
  },
  icon: {
    fontSize: 64,
    color: theme.palette.grey[400],
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  message: {
    color: theme.palette.text.secondary,
    maxWidth: 400,
  },
}));

/**
 * Empty state component displayed when no data is available
 */
const EmptyState = ({ title, message, onClearFilters }) => {
  const classes = useStyles();

  return (
    <div className={classes.root} role="status" aria-live="polite">
      <Inbox className={classes.icon} aria-hidden="true" />
      <Typography variant="h6" className={classes.title}>
        {title || 'Nenhum resultado encontrado'}
      </Typography>
      {message && (
        <Typography variant="body2" className={classes.message}>
          {message}
        </Typography>
      )}
      {onClearFilters && (
        <Typography 
          variant="body2" 
          className={classes.message}
          style={{ marginTop: 16, cursor: 'pointer', textDecoration: 'underline' }}
          onClick={onClearFilters}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClearFilters();
            }
          }}
        >
          Limpar filtros
        </Typography>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onClearFilters: PropTypes.func,
};

EmptyState.defaultProps = {
  title: 'Nenhum resultado encontrado',
  message: 'Tente ajustar os filtros para encontrar o que procura.',
  onClearFilters: null,
};

export default EmptyState;
